<template>
  <div>
    <h3 class="rs-data-title">{{tituloTabela}}</h3>
    <v-data-table
      dense
      hide-actions
      hide-headers
      class="elevation-1"
      :headers="headers"
      :items="bugList"
      :loading="loadingActive"
      item-key="bug_id"
      no-results-text="Nada foi encontrado."
      :no-data-text="noDataText"
    >
      <template v-slot:items="props">
        <tr>
          <td>
            <md-icon class="rs-priority-icon" v-if="props.item.priority == 'Candidate'" style="color: #ffcc66;">warning</md-icon>
            <md-icon class="rs-priority-icon" v-else-if="props.item.priority == 'Imediato'" style="color: #ff6666;">cancel</md-icon>
            <md-icon class="rs-priority-icon" v-else></md-icon>
            <a target="_blank" :href="'https://bug.realtec.com.br/show_bug.cgi?id=' + props.item.bug_id">{{props.item.bug_id}}</a>
          </td>
          <td>{{ props.item.component || "---" }}</td>
          <td>{{ props.item.short_desc || "---" }}</td>
          <td>{{ props.item.priority }}</td>
        </tr>
      </template>

      <template v-slot:expand="props">
      </template>
    </v-data-table>     
  </div>
</template>
<script>

export default {
  props: ["bugList", "loadingActive", "noDataText", "tituloTabela"],
  data() {
      return {
        bugs: [],
        headers: [
          {
            text: "Produto",
            value: "bug_id"
          },
          {
            text: "Produto",
            value: "component"
          },
          {
            text: "Versão",
            value: "short_desc"
          },
          {
            text: "Versão Interna",
            value: "priority"
          }
        ]
      }
  },
  components:{
  },
  created() {
    
  },
  methods: {
    
  }  
};
</script>
<style scoped>
.subtitle-2 {
  min-height: 30px;
}
.overlayy {
  z-index: 10;
  background: rgba(0, 0, 0, 0.39);
  position: absolute;
  width: 100%;
  height: 99%;
  top: 0;
  border-radius: 5px;
  left: 0;
}
li {
  min-height: 58px;
}

span,
div,
table,
td,
tr,
th {
  transition: all 0.3s ease !important;
}

/*.md-theme-default a:not(.md-button) {
  color: #2b5577 !important;
}*/

.md-theme-default a:hover {
  color: #00aaff !important;
  text-decoration: underline !important;
}

table.v-table tbody td, table.v-table tbody th{
  height: 25px;
}

.rs-data-title{
  display: flex;
  justify-content: center;
}

.rs-priority-icon{
  margin-right: 10px;
  font-size: 20px !important;
}

</style>